'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _templateObject = _taggedTemplateLiteral(['\n  background-color: ', ';\n'], ['\n  background-color: ', ';\n']);

exports.default = HR;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactUtils = require('react-utils');

var _Hr = require('../vendor/canvas/Hr');

var _Hr2 = _interopRequireDefault(_Hr);

var _DistanceConstants = require('../layout/DistanceConstants');

var _theme = require('HubStyleTokens/theme');

var _styledComponents = require('styled-components');

var _styledComponents2 = _interopRequireDefault(_styledComponents);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _taggedTemplateLiteral(strings, raw) { return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }

var StyledHR = (0, _styledComponents2.default)(_Hr2.default).withConfig({
  displayName: 'HR__StyledHR'
})(_templateObject, _theme.HR_BORDER_COLOR);

var getClasses = function getClasses(className, distance) {
  return (0, _reactUtils.classNames)('namespaced-hack-hr', className, _DistanceConstants.DISTANCE_CLASSES[distance]);
};

function HR(_ref) {
  var className = _ref.className,
      distance = _ref.distance,
      rest = _objectWithoutProperties(_ref, ['className', 'distance']);

  return _react2.default.createElement(StyledHR, _extends({}, rest, { className: getClasses(className, distance) }));
}

HR.propTypes = {
  className: _react.PropTypes.string,
  distance: _react.PropTypes.oneOf(Object.keys(_DistanceConstants.DISTANCE_CLASSES)).isRequired
};

HR.defaultProps = {
  distance: 'medium'
};

HR.displayName = 'HR';
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// /usr/share/hubspot/build/.hubspot/static-archive/UIComponents/static-2.1282/js/elements/HR.js
// module id = 353
// module chunks = 0